/**
 * AUA HYDRATE — Scroll reveal
 * Lightweight IntersectionObserver attaching .is-revealed to [data-reveal] elements.
 * Respects prefers-reduced-motion (handled via CSS duration override).
 */
(() => {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  const attach = () => {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => {
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  // Re-scan on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', attach);
})();
